import React, { Component } from 'react'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import { gotoPoster } from '@util'

@observer
export default class extends Component {
  render() {
    const {
      posterStore: { topRightBannerPoster }
    } = mainStore

    return topRightBannerPoster.image_path ? (
      <div
        style={{ marginBottom: 16 }}
        onClick={() => gotoPoster(topRightBannerPoster)}
      >
        <img
          src={topRightBannerPoster.image_path}
          style={{ height: 260, width: 320, cursor: 'pointer' }}
        />
      </div>
    ) : null
  }
}
